import { localStorage } from "../../../helpers/fnc";

import { setOrganizationId } from "../state/organizationId";
import { setOrganizationType } from "../state/organizationType";

export default function selectOrganization({ id, type, user }) {
	setOrganizationId(id);
	setOrganizationType(type);

	localStorage("organizations", user.id, {
		id: id,
		type: type,
	});
}
